
export enum ProductProviderEnum {
  Internal = 0,
  Amazon = 1,
  Shein = 2,
  Walmart=3,
  HomeDepot=4,
  BestBuy=5,
}

export const ProductProviderMapping: Record<ProductProviderEnum, string> = {
  [ProductProviderEnum.Internal]: 'Cubatel',
  [ProductProviderEnum.Amazon]: 'Amazon',
  [ProductProviderEnum.Shein]: 'Shein',
  [ProductProviderEnum.Walmart]: 'Walmart',
  [ProductProviderEnum.HomeDepot]: 'HomeDepot',
  [ProductProviderEnum.BestBuy]: 'BestBuy'
};
